import React from 'react';
import { Loading } from '@fpxfd/next';
import styles from './index.module.scss';

const LoadingCom = () => {
  return <Loading className={styles.container} />;
};

export default LoadingCom;
